import Vue from 'vue';
import Main from './Main.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

// To use the env override:
// -make a file named ".env.local"
// -set the contents to: "VUE_APP_OVERRIDE_API=https://api.alpha.mtgfakefinder.com"
let mffApiHost = '';
if (process.env.VUE_APP_OVERRIDE_API) {
  mffApiHost = process.env.VUE_APP_OVERRIDE_API;
} else if (window.location.hostname === 'www.mtgfakefinder.com') {
  mffApiHost = 'https://api.mtgfakefinder.com';
} else if (window.location.hostname === 'beta.mtgfakefinder.com') {
  mffApiHost = 'https://api.alpha.mtgfakefinder.com';
} else if (window.location.hostname === 'localhost') {
  mffApiHost = 'https://localhost:5001';
} else {
  mffApiHost = `${window.location.protocol}//api.${window.location.hostname}`;
}

new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit('initApiHost', mffApiHost);
    this.$store.commit('initBearerTokenFromStorage');
    this.$store.dispatch('user/fetchUserAsync');
  },
  render: h => h(Main),
}).$mount('#main');
